import { useState, useContext } from 'react';

import Input from '../../../../../components/input-with-label';

import Popup from '../../../../../components/popup';

import { DeleteButton, CancelButton } from '../../../../../components/buttons';

import ELearningAPI from '../../../../../lib/e-learning/e-learning-api';

import PopupContext from '../../../../../context/context-popup';

export default function ELearningDelete({ path, onSuccess }) {
    const { setPopup } = useContext(PopupContext);

    const deletePath = () => {
        new ELearningAPI().deleteLearningPath(path).then(() => {
            onSuccess();
        });
    }

       return (
        <Popup onClose={setPopup}>
            <div class="popup__inner">
                <h1>Are you sure?</h1>
                <p>You are about to delete the learners path, this cannot be undone</p>

                <div class="popup__buttons">
                    <DeleteButton responsive={false} onClick={deletePath}/>
                    <CancelButton responsive={false} onClick={() => setPopup(null)}/>
                </div>
            </div>
        </Popup>
    )
}
